import {HOST_URL, DESTROY_SESSION, SET_SESSION} from '../constants';
 
import get_header from './api_header'
import {parseHeaders} from './api_header'

export function recoveryAccount(authentication_token, type, attributes, success, error) {
  return (dispatch) => {
    return fetch(HOST_URL+'api/v1/recovery', {
      method: 'POST',
      headers: get_header(authentication_token),
      body: JSON.stringify({ type: type, attributes: attributes})
    })
    .then((response) => parseHeaders(response, dispatch))
    .then((response) => {
      if (response.ok) {
        response.json().then((responseJson) => {
          success(responseJson)
        })	
      }
      else{
        response.json().then((responseJson) => {
          error(responseJson)
        })
      	
      }

    })
    .catch((error) => {
      console.error(error);
    });
  }
}

export function getSecurityQuestions(token, success, error) {
  return (dispatch) => {
    return fetch(HOST_URL+'security_questions?token='+token, {
      method: 'GET',
      headers: get_header(""),
    })
    .then((response) => parseHeaders(response, dispatch))
    .then((response) => {
      if (response.ok) {
        response.json().then((responseJson) => {
          success(responseJson.security_questions, responseJson.user_language)
        })  
      }
      else{
        error()
      }

    })
    .catch((error) => {
      console.error(error);
    });
  }
}


export function resendSMS(authentication_token, attributes, success, error) {
  return (dispatch) => {
    return fetch(HOST_URL+'api/v1/sms', {
      method: 'POST',
      headers: get_header(authentication_token),
      body: JSON.stringify({attributes: attributes})      
    })
    .then((response) => parseHeaders(response, dispatch))
    .then((response) => {
      if (response.ok) {
        response.json().then((responseJson) => {
          success()
        })  
      }
      else{
        error()
      }

    })
    .catch((error) => {
      console.error(error);
    });
  }
}

export function resendSMSRecovery(authentication_token, attributes, success, error) {
  return (dispatch) => {
    return fetch(HOST_URL+'sms', {
      method: 'POST',
      headers: get_header(authentication_token),
      body: JSON.stringify({attributes: attributes})      
    })
    .then((response) => parseHeaders(response, dispatch))
    .then((response) => {
      if (response.ok) {
        response.json().then((responseJson) => {
          success()
        })  
      }
      else{
        error()
      }

    })
    .catch((error) => {
      console.error(error);
    });
  }
}


